import React, { useState } from "react";
import { Button, message } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router";
import Header from "../../components/Header/Header";
import { BackButton } from "../../components/General/BackButton";
import PaymentElementModal from "../../components/Stripe/PaymentElementModal";
import { createPaymentMethodsSheet } from "../../api/stripeApi/setupIntent";

/**
 * Add-card screen (Stripe). Fetches a SetupIntent from the backend and confirms
 * it via a Payment Element in `setup` mode, so the card is saved off-session for
 * later charges — no raw card data ever touches our DOM (PCI SAQ A). Replaces the
 * legacy raw-card form under the Stripe flag.
 */
export const StripeAddCard = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [clientSecret, setClientSecret] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAddCard = async () => {
    setLoading(true);
    const data = await createPaymentMethodsSheet();
    setLoading(false);
    if (data?.setupIntent) {
      setClientSecret(data.setupIntent);
      setModalVisible(true);
    }
  };

  const handleSuccess = () => {
    setModalVisible(false);
    setClientSecret(null);
    message.success(intl.formatMessage({ id: "CARD_SAVED" }));
    navigate(-1);
  };

  const handleCancel = () => {
    setModalVisible(false);
    setClientSecret(null);
  };

  return (
    <>
      <Header />
      <div className="container mt-4">
        <BackButton />
        <div className="d-flex flex-column align-items-center mt-5">
          <Button
            type="primary"
            onClick={handleAddCard}
            loading={loading}
            className="fw-bold"
          >
            <FormattedMessage id="ADD_CARD" />
          </Button>
        </div>
      </div>
      <PaymentElementModal
        visible={modalVisible}
        mode="setup"
        clientSecret={clientSecret}
        title={<FormattedMessage id="ADD_CARD" />}
        submitLabel={<FormattedMessage id="SAVE_CARD" />}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </>
  );
};

export default StripeAddCard;
